<template>
  <div class="ds-info-box ds-info-box--warning identical-file-notice" role="status">
    <v-icon class="ds-info-box__icon" small>mdi-file-compare</v-icon>
    <div class="ds-info-box__content">
      <div class="identical-file-notice__headline">
        Identical to {{ versionNumber ? `v${versionNumber}` : 'the current version' }}<template v-if="versionNumber">, the current version</template>
      </div>
      <div class="identical-file-notice__detail">
        Same content, byte for byte, as <span class="identical-file-notice__file" :title="fileName">{{ fileName || 'that version' }}</span
        ><template v-if="sizeText"> ({{ sizeText }})</template>. {{ hint }}
      </div>
      <!-- The proof: both files have the same SHA-256 fingerprint. -->
      <div v-if="hashText" class="identical-file-notice__fingerprint" :title="`SHA-256 ${contentHash}`">
        <span class="identical-file-notice__algo">SHA-256</span>
        <span>{{ hashText }}</span>
        <v-icon x-small class="identical-file-notice__match">mdi-equal</v-icon>
        <span>{{ versionNumber ? `v${versionNumber}` : 'current' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { fileSizeLabel, shortHash } from '../utils/documentVersions';

  /**
   * Warns that a chosen file has exactly the content of a document's current version, and shows
   * the matching SHA-256 so the user can trust the claim. `hint` says what the user can do here.
   */
  export default {
    name: 'IdenticalFileNotice',
    props: {
      versionNumber: { type: Number, default: null },
      fileName: { type: String, default: '' },
      size: { type: Number, default: null },
      contentHash: { type: String, default: '' },
      hint: { type: String, default: '' },
    },
    computed: {
      sizeText() {
        return this.size != null ? fileSizeLabel(this.size) : '';
      },
      hashText() {
        return shortHash(this.contentHash);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .identical-file-notice {
    &__headline {
      font-weight: 600;
      line-height: 1.35;
    }

    &__detail {
      margin-top: 2px;
      line-height: 1.45;
    }

    &__file {
      font-weight: 500;
      word-break: break-all;
    }

    &__fingerprint {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      margin-top: var(--ds-space-xs);
      font-family: var(--ds-font-family-mono);
      font-size: var(--ds-font-caption);
      opacity: 0.75;
    }

    &__algo {
      font-size: var(--ds-font-micro);
      letter-spacing: 0.06em;
    }

    &__match {
      color: var(--v-golden-base) !important;
    }
  }
</style>
